module.exports = __webpack_public_path__ + "static/Banner_noon_Tax_63_Desktop.b0e8a989.png";